import { html, node } from 'wirejs-dom/v2';
import { ProFeatures } from '../../services';
import Alert from './alert';
import Tracker from '../navigation/tracker';

const tracker = new Tracker();

/**
 * @param {string} name
 */
function adsenseTrackConversion(name) {
	if (name.toLowerCase().includes('advanced')) {
		gtag('event', 'conversion', {
			'send_to': 'AW-1071238746/Tt7qCKu3hqwaENqc5_4D',
			'value': 49.0,
			'currency': 'USD',
		});
	} else if (name.toLocaleLowerCase().includes('ultimate')) {
		gtag('event', 'conversion', {
			'send_to': 'AW-1071238746/g_FwCK63hqwaENqc5_4D',
			'value': 349.0,
			'currency': 'USD'
		});
	}
}

/**
 * 
 * @param {{
 * 	id: string;
 * 	price: number;
 * 	type: 'recurring' | 'one_time';
 * 	interval: 'month' | 'year' | undefined;
 * }} pricing 
 * @returns 
 */
const buyButton = ({ id, name, price, type, interval }) => html`
   <button
	   onclick=${async (evt) => {
		evt.target.disabled = true;
		const user = await ProFeatures.getUserId();
		if (user) {
			tracker.track('begin_checkout', {
				currency: 'USD',
				value: (
					(type === 'one_time' || interval === 'year')
					? price : price * 12
				) / 100,
				items: [{
					item_id: id,
					item_name: name
				}]
			});
			adsenseTrackConversion(name);
			document.location = await ProFeatures.getUpgradeLink(id);
		} else {
			tracker.track('view_item', {
				currency: 'USD',
				value: (
					(type === 'one_time' || interval === 'year')
					? price : price * 12
				) / 100,
				items: [{
					item_id: id,
					item_name: name
				}]
			});
			new Alert({
				message: `<h3>Sounds good!</h3>
					<p>You just need to sign in so we know who to give the goods to!</p>
				`,
			});
			evt.target.disabled = false;
		}
	}}
	   style='
		   margin: 1rem;
		   padding: 0.25rem 1rem;
		   border-radius: 1rem;
		   border-color: darkorange;
		   background-color: orange;
		   font-size: 1rem;
		   font-family: monospace;
		   user-select: none;
		   cursor: pointer;
	   '
   >$${(price / 100).toFixed(2)}${
		type === 'recurring' ? `/${interval}` : ' (<b>One Time</b>)'
	}</button>
`;

/**
 * 
 * @param {Record<string, boolean>} userFeatures
 * @returns 
 */
export const PricingTable = async () => {
	const userFeatures = await ProFeatures.getFeatures();
	const options = await ProFeatures.getUpgradeOptions();

	// sort products by price ascending, accoring to the lowest pricing
	// listed for each product.
	options.sort((a, b) =>
		Math.min(...a.prices.map(p => p.price))
		- Math.min(...b.prices.map(p => p.price))
	);

	return html`<div>
	   ${options.map(product => html`<div style='margin-bottom: 2rem;'>
		   <h3>${product.name}</h3>
		   <div style='text-align: left;'>${product.description}
			   <ul>${product.marketing_features.map(
					f => html`<li>${f.name}</li>`
				)}</ul>
		   </div>
		   ${node('prices', () => {
				if (product.features.every(f => userFeatures[f])) {
					return html`<div style='
						margin: 1rem 0.5rem;
						padding: 0.25rem;
						font-size: 1.1rem;
						font-weight: bold;
					'>✅ You have these features.</div>`;
				} else {
					return html`<div>${product.prices
						.sort((a, b) => a.price - b.price)
						.map(price => buyButton({
							name: product.name,
							...price
						}))
					}</div>`;
				}
			})}
			<hr />
		</div>`)}
	</div>`;
};
